export const STATUS_META = {
  new: { label: "New Lead", color: "bg-blue-100 text-blue-700 border-blue-200", dot: "bg-blue-500" },
  contacted: { label: "Contacted", color: "bg-amber-100 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  quote_sent: { label: "Quote Sent", color: "bg-violet-100 text-violet-700 border-violet-200", dot: "bg-violet-500" },
  booked: { label: "Booked", color: "bg-emerald-100 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  completed: { label: "Completed", color: "bg-brandgreen/15 text-brandgreen-dark border-brandgreen/30", dot: "bg-brandgreen" },
  cancelled: { label: "Cancelled", color: "bg-gray-100 text-gray-600 border-gray-200", dot: "bg-gray-400" },
  declined: { label: "Declined", color: "bg-red-100 text-red-700 border-red-200", dot: "bg-red-500" },
};

export const STATUS_ORDER = ["new", "contacted", "quote_sent", "booked", "completed", "cancelled", "declined"];

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-AU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
